var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLockLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99955 0C5.95388 0 4.30724 1.64663 4.30724 3.69231V6.15385C2.95388 6.15385 1.8457 7.26202 1.8457 8.61539V13.5385C1.8457 14.8918 2.95388 16 4.30724 16H11.6919C13.0452 16 14.1534 14.8918 14.1534 13.5385V8.61539C14.1534 7.26202 13.0452 6.15385 11.6919 6.15385V3.69231C11.6919 1.64663 10.0452 0 7.99955 0ZM7.99955 1.23077C9.40099 1.23077 10.4611 2.29087 10.4611 3.69231V6.15385H5.53801V3.69231C5.53801 2.29087 6.59811 1.23077 7.99955 1.23077ZM7.99955 9.23077C8.67743 9.23077 9.23032 9.78365 9.23032 10.4615C9.23032 10.8918 8.98513 11.3149 8.61493 11.5V12.9231C8.61493 13.2933 8.36974 13.5385 7.99955 13.5385C7.62936 13.5385 7.38416 13.2933 7.38416 12.9231V11.5C7.01397 11.3149 6.76878 10.8918 6.76878 10.4615C6.76878 9.78365 7.32167 9.23077 7.99955 9.23077Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLight);
export default __webpack_public_path__ + "static/media/lockLight.8702a405d12618c5f3c230fd36d5b20b.svg";
export { ForwardRef as ReactComponent };